<template lang="html">
  <div class="top-section-wrapper">
    <categories :categories="categories" @changeCategory="changeCategory" />
    <div class="left">
      <carousel
        style="width:100%"
        :showVideo="showVideo"
        @changeShowVideo="$emit('changeShowVideo', $event)"
        :images="images"
      />
      <!-- <div
        class="card"
        style="height: 114px; background-color: antiquewhite; margin-top: 30px;"
      >
        card
      </div> -->
      <wrappCard @goTo="$emit('goTo', $event)"></wrappCard>
    </div>
  </div>
</template>

<script>
import { api, baseURL } from "@/api";
import Carousel from "@/components/topSection/carousel.vue";
import Categories from "@/components/topSection/categories.vue";
import wrappCard from "@/components/topSection/wrappCard";
export default {
  name: "topSectionWrapper",
  props: ["showVideo"],
  components: {
    Carousel,
    Categories,
    wrappCard
  },
  data() {
    return {
      images: [],
      categories: null
    };
  },
  mounted() {
    this.getImages();
    this.getCategories();
  },
  methods: {
    getImages() {
      api
        .getBanners()
        .then(res => {
          for (var i = 0; i < res.data.data.length; i++) {
            this.images.push(baseURL + res.data.data[i].image);
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    changeCategory(category) {
      const query = {
        category: category.cat_id
      };
      this.$router.push({
        name: "Result",
        params: this.$route.params,
        query: query
      });
    },
    getCategories() {
      api
        .getCategories()
        .then(res => {
          for (var i = 0; i < res.data.data.length; i++) {
            res.data.data[i].open = false;
          }
          this.categories = res.data.data;
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  watch: {
    "$route.params.lang": {
      handler: function() {
        this.getCategories();
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.top-section-wrapper {
  display: flex;
  flex-direction: row;
  margin-bottom: 70px;
  margin-top: 50px;
  .left {
    width: calc(100% - 288px);
  }
}
@media only screen and (max-width: 1000px) {
  .top-section-wrapper {
    margin-bottom: 20px;
    .left {
      width: 100%;
    }
  }
  .categories-wrapper {
    display: none;
  }
}
</style>
